module.exports = __webpack_public_path__ + "img/bg_blue_full.1ed1091d.jpg";